/*
 * @Author: Tina Huang
 * @Date: 2025-02-06 15:36:22
 * @LastEditors: Tina Huang
 * @LastEditTime: 2025-02-26 15:37:38
 * @Description:
 */
import { qaList, TypeTag } from '@/constants/qa'
import { CheckCircleFilled, QuestionCircleOutlined, StarFilled } from '@ant-design/icons'
import { Button, Input, List, Rate, Tag, message } from 'antd'
import { useMemo, useState } from 'react'
import { useNavigate } from 'react-router-dom'

export default function QASpace() {
  const navigate = useNavigate()
  const [collections, setCollections] = useState<string[]>(JSON.parse(localStorage.getItem('qaCollections') || '[]'))
  const [showCollection, setShowCollection] = useState(false)
  const [keywords, setKeywords] = useState('')
  const [messageApi, contextHolder] = message.useMessage()

  const orgList = useMemo(() => {
    console.log(keywords)
    const _org = qaList.map((cur) => {
      const _c = collections.find((cc) => cc === cur?.id)
      return {
        ...cur,
        like: _c ? true : false,
      }
    })
    let cal_list = _org
    if (keywords) {
      cal_list = cal_list.filter((cur) => cur?.title?.indexOf(keywords) > -1)
    }
    return showCollection ? cal_list.filter((item) => item?.like) : cal_list
  }, [collections, showCollection, keywords])

  const handleQaDetail = (id: string, item: any) => {
    if (!item?.answer) return messageApi.warning('正在更新中～敬请期待～')
    if (item?.link) {
      return window.open(item?.link)
    }
    navigate(`/qa/${id}`)
    // fetch(`/QA-Answer/${id}.md`)
    //   .then((resp) => resp?.text())
    //   .then((txt) => setMdStr(txt))
  }

  const handleCollect = (id: string) => {
    if (collections.find((cur) => cur === id)) {
      // cancel
    } else {
      // add
      const newCollections = [...collections, id]
      setCollections(newCollections)
      localStorage.setItem('qaCollections', JSON.stringify(newCollections))
    }
  }

  return (
    <div>
      {contextHolder}
      <div className="flex justify-between mb-4">
        <Input.Search placeholder="问题关键词" allowClear onSearch={(v) => setKeywords(v)} />
        <Button
          type="primary"
          className="ml-8"
          icon={<QuestionCircleOutlined />}
          onClick={() => window.open('https://httishere666.notion.site/1856018c38ee80148aded614858e4d3b?pvs=105')}
        >
          提交我的疑问
        </Button>
        <Button type="text" className="ml-4" onClick={() => setShowCollection(!showCollection)}>
          {showCollection ? '👀 查看全部' : <>⭐️ 我的收藏({collections.length})</>}
        </Button>
      </div>
      <List
        className="bg-white"
        size="large"
        bordered
        pagination={{ position: 'bottom', align: 'center', pageSize: 15 }}
        dataSource={orgList}
        renderItem={(item) => (
          <List.Item
            className="cursor-pointer"
            actions={[
              // <Rate disabled value={item?.level} character="🔥" className="m-0 leading-none" />,
              <div
                className={`cursor-pointer font-bold ${!item?.like ? 'text-gray-200' : 'text-yellow-400'}`}
                onClick={() => handleCollect(item?.id)}
              >
                <StarFilled /> 收藏
              </div>,
            ]}
          >
            <div onClick={() => handleQaDetail(item?.id, item)}>
              {item.answer ? <CheckCircleFilled className="text-green-600" /> : <QuestionCircleOutlined />}
              <Tag color={TypeTag?.[item?.type]} className="ml-4">
                {item?.type}
              </Tag>
              {item?.title}
            </div>
            <div></div>
          </List.Item>
        )}
      />
    </div>
  )
}
